import { Fragment } from "react";
import { Helmet } from "react-helmet";
import PatientSidebar from "./PatientSidebar";
import PatientTabs from "./PatientTabs";
import { initialState, patientDetailsReducer, } from "./store/PatientDetailsReducer";
import { StoreProvider } from "./store/Store";

const PatientDetail = ({ hideSidebar = false, historySection = false, pastTab=false }) => {
  console.log(hideSidebar, historySection, pastTab);
  return (
    <Fragment>
      <StoreProvider initialState={initialState} reducer={patientDetailsReducer}>
        <Helmet>
          <title>Patient Detail | DOCG</title>
        </Helmet>
        <div className={hideSidebar ? "patient-wrapper " : "patient-wrapper docg-vh-standard"}>
          <div className="">{!hideSidebar && <PatientSidebar />}</div>
          {hideSidebar ? (
            <>
              <PatientTabs historySection={historySection} pastTab={pastTab} />
            </>
          ) : (
            <div className="patient-tab">
              <PatientTabs historySection={historySection} />
            </div>
          )}
        </div>
      </StoreProvider>
    </Fragment>
  );
};

export default PatientDetail;
